import * as React from 'react'
import { tw } from 'utils/classnames'

type CarouselControlButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>

export function CarouselControlButton({
  children,
  className,
  disabled,
  ...rest
}: React.PropsWithChildren<CarouselControlButtonProps>) {
  return (
    // oxlint-disable-next-line react/button-has-type
    <button
      className={tw(
        'bg-cf-dreamy-cloud-400 hover:bg-cf-dreamy-cloud-500 text-cf-dreamy-cloud-1000 disabled:hover:bg-cf-dreamy-cloud-500 mb-1 flex h-10 w-10 items-center justify-center rounded-full disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  )
}
